import TopStrip from "./components/TopStrip";
import Header from "./components/Header";
import FeaturedCard from "./components/FeaturedCard";
import HotRank from "./components/HotRank";
import FeedGrid from "./components/FeedGrid";
import DeepDive from "./components/DeepDive";
import Voices from "./components/Voices";
import TrustFaq from "./components/TrustFaq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen w-full bg-background-50 text-foreground-900 antialiased">
      <TopStrip />
      <Header />
      <FeaturedCard />
      <HotRank />
      <FeedGrid />
      <DeepDive />
      <Voices />
      <TrustFaq />
      <Footer />
    </main>
  );
}